import { cn } from "@/utils/cn";
import React, { ElementType, ReactNode } from "react";
export { BillingBadge } from "@/components/ui";

// ============= Card ================
export const ComponentCard = ({
  children,
  style,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <div
      className={cn(
        "space-y-4 rounded-xl border border-edge-light p-4",
        className,
      )}
      style={style}
    >
      {children}
    </div>
  );
};

// ============= Title ================
type CComponentHeaderProps = {
  children?: ReactNode;
  text?: string;
  as?: ElementType;
};

export function ComponentHeader({
  children,
  text,
  as: C = "h2",
}: CComponentHeaderProps) {
  const content = children ?? text;
  const className =
    "font-erode-variable text-[32px] font-normal leading-[110%] tracking-[-0.96px] md:text-[40px] md:leading-[44px] md:tracking-[-1.2px]";
  return <C className={className}>{content}</C>;
}

// ============= Desc ================
type ComponentDescProps = {
  children?: ReactNode;
  text?: string;
  as?: ElementType;
  className?: string;
};

export function ComponentDesc({
  children,
  text,
  as: Tag = "p",
  className = "",
}: ComponentDescProps) {
  const content = children ?? text;
  const baseClasses =
    "my-5 w-full wrap-break-word font-archivo text-[16px] font-light leading-[22.4px] tracking-[0.16px] text-[#323232] md:my-6 md:px-4 md:py-4";
  return <Tag className={`${baseClasses} ${className}`}>{content}</Tag>;
}
